"use client"

import { createContext, useContext, useState, useCallback, useMemo, type ReactNode } from "react"

interface AccountSwitcherContextValue {
    isOpen: boolean
    open: () => void
    close: () => void
}

const AccountSwitcherContext = createContext<AccountSwitcherContextValue | null>(null)

export function AccountSwitcherProvider({ children }: { children: ReactNode }) {
    const [isOpen, setIsOpen] = useState(false)

    const open = useCallback(() => setIsOpen(true), [])
    const close = useCallback(() => setIsOpen(false), [])

    // Memoize context value to prevent consumer re-renders when provider re-renders
    const value = useMemo(() => ({ isOpen, open, close }), [isOpen, open, close])

    return <AccountSwitcherContext.Provider value={value}>{children}</AccountSwitcherContext.Provider>
}

export function useAccountSwitcher() {
    const context = useContext(AccountSwitcherContext)
    if (!context) {
        throw new Error("useAccountSwitcher must be used within AccountSwitcherProvider")
    }
    return context
}
